import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class SessionStorageService {
	getValue<T extends object>(prefKey: string, defaultValue: T): T {
		if (typeof Storage === "undefined") {
			console.log("no storage support");
			return { ...defaultValue };
		} else if (prefKey.includes(".")) {
			throw new Error("Invalid session storage key");
		}
		const sessionStorageStringValue = sessionStorage[prefKey];
		if (sessionStorageStringValue) {
			const sessionStorageJSONValue = JSON.parse(sessionStorageStringValue);
			return { ...defaultValue, ...sessionStorageJSONValue };
		}
		return { ...defaultValue };
	}

	setValue<T extends object>(prefKey: string, value: T): void {
		if (typeof Storage === "undefined") {
			console.log("no storage support");
		} else if (prefKey.includes(".")) {
			throw new Error("Invalid session storage key");
		} else {
			sessionStorage[prefKey] = JSON.stringify(value);
		}
	}

	delValue(prefKey: string): void {
		if (typeof Storage === "undefined") {
			console.log("no storage support");
		} else if (prefKey.includes(".")) {
			throw new Error("Invalid session storage key");
		} else {
			sessionStorage.removeItem(prefKey);
		}
	}

	clearValues(): void {
		sessionStorage.clear();
	}
}
